import { useDispatch } from "react-redux";
import { openPopup } from "../../store/popupSlice"

export default function Landing2Market() {
  const dispatch = useDispatch();
  return (
    <>
      <section className="land2-market">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="land2-market-details">
                <div className="row">
                  <div className="col-lg-7 col-xl-5">
                    <label>take action</label>
                    <h3 className="heading"><span> Stay Connected  </span> with your market</h3>
                    <p>Partner with Mobility Infotech to streamline operations, boost efficiency, and future-proof your taxi business.</p>
                    <button onClick={() => dispatch(openPopup())} className="default-white">Get in touch</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
